import { Container, Flex, LoadingOverlay, Text } from "@mantine/core";
import React, { useEffect } from "react";
import { AppResources } from "@/constants.ts";

interface OneClickLoaderProps {
  visible: boolean;
}

const OneClickLoader: React.FC<OneClickLoaderProps> = ({ visible }) => {
  const overLayContent = (): JSX.Element => {
    return (
      <Flex direction="column" align="center" justify="center" mt={20} gap={10}>
        <img
          src={AppResources.glassesLogo}
          alt="Loading"
          style={{
            animation: "bounce 2s infinite",
          }}
        />
        <Text
          size={"25px"}
          mt={25}
          style={{
            animation: "fadeIn 4s ease-in-out infinite",
          }}
        >
          Preparing your client's information ✨
        </Text>
        <style>
          {`
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            50% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
          `}
        </style>
        <Text size="sm" c="dimmed">
          This may take a few moments.
        </Text>

        <Container
          bg={"#FCF8E8"}
          p={10}
          m={0}
          mt={5}
          bd={" 1px solid #2D2406"}
          style={{ borderRadius: "10px" }}
        >
          <Text size="sm" c="#2D2406">
            Hang tight! Please don’t refresh, close or navigate away from this
            page.
          </Text>
        </Container>
        <style>
          {`
        @keyframes bounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        `}
        </style>
      </Flex>
    );
  };
  useEffect(() => {
    // Prevent scrolling when the overlay is visible
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [visible]);

  return (
    <LoadingOverlay
      visible={visible}
      zIndex={1000}
      overlayProps={{ radius: "sm", blur: 2 }}
      loaderProps={{
        children: overLayContent(),
      }}
    />
  );
};

export default OneClickLoader;
